import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { getListingsSupportedCurrencies } from '../selectors';
import { fetchListingsSupportedCurrencies } from '../actions';

export const useListingsSupportedCurrencies = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchListingsSupportedCurrencies());
  }, [dispatch]);

  return useSelector(getListingsSupportedCurrencies);
};
